/* API ERROR CODES */

export const TOKEN_NOT_VALID = "token_not_valid";
export const USER_INACTIVE = "user_inactive";
export const PERMISSION_DENIED_ACCEPT_INVITE =
  "permission_denied_accept_invite";
export const INVALID_INPUT = "invalid";
export const PERMISSION_DENIED = "permission_denied";
